import styled from "styled-components";
import { Icon, transition } from "@evergis/ui";

export const TooltipIcon = styled(Icon)`
  &&& {
    :after {
      font-size: 0.75rem;
      color: ${({ theme: { palette } }) => palette.iconDisabled};
      transition: color ${transition.hover};
    }

    :hover:after {
      color: ${({ theme: { palette } }) => palette.icon};
    }
  }
`;
